export default __webpack_public_path__ + "static/media/creddit-screen2.aba1f80a.png";